import Layout from './layout'

const LayoutRouter = _forEach(Layout, [])

function _forEach(data: any, result: any) {
  for (let i = 0; i < data.length; i++) {
    const item = data[i]
    if (!item.children) {
      result.push(item)
    } else {
      _forEach(item.children, result)
    }
  }
  return result
}

const ConfigRoutes: any = [
  {
    path: '/login',
    component: () => import('@/views/Login/index.vue'),
    meta: {
      title: '登录'
    }
  },
  {
    path: '',
    component: () => import('@/layout/index.vue'),
    redirect: LayoutRouter[0].path,
    children: LayoutRouter
  },

  {
    path: '/404',
    component: () => import('@/views/404.vue')
  },
  {
    path: '*',
    redirect: '/404',
    meta: {
      title: 404
    }
  }
]

export default ConfigRoutes
